document.addEventListener('DOMContentLoaded', () => {
  // Names repeater
  document.querySelectorAll('.js-names-repeater').forEach((wrap) => {
    const list = wrap.querySelector('.js-repeater-list');
    const addBtn = wrap.querySelector('.js-repeater-add');
    const removeBtn = wrap.querySelector('.js-repeater-remove');
    const max = parseInt(wrap.getAttribute('data-max') || '5', 10);

    const updateState = () => {
      const rows = list.querySelectorAll('.js-repeater-row');
      removeBtn.disabled = rows.length <= 1;
      addBtn.disabled = rows.length >= max;
      // Update names
      rows.forEach((row, idx) => {
        const input = row.querySelector('input[name^="properties["]');
        if (input) {
          input.name = `properties[Names ${idx + 1}]`;
          input.placeholder = `Name ${idx + 1}`;
        }
      });
    };

    addBtn?.addEventListener('click', () => {
      const rows = list.querySelectorAll('.js-repeater-row');
      if (rows.length >= max) return;
      const clone = rows[rows.length - 1].cloneNode(true);
      const input = clone.querySelector('input');
      if (input) {
        input.value = '';
      }
      list.appendChild(clone);
      updateState();
    });

    removeBtn?.addEventListener('click', () => {
      const rows = list.querySelectorAll('.js-repeater-row');
      if (rows.length <= 1) return;
      list.removeChild(rows[rows.length - 1]);
      updateState();
    });

    updateState();
  });
});




